<template>
  <div class="Bgc-white">
    <Header />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row">
          <div class="col-12 mb-0">
            <p class="title mb-4">{{titleModificacioneReservaciones}}</p>
            <p class="link f-w-500 mb-2">
              <i class="demo-icon icon-travel"></i>
              {{$t('language.posadasCorporate.modificacionReservaciones.datosGenerales')}}
            </p>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.modificacionReservaciones.clienteID')}}*</label>
              <div class="Pos-r">
                <input type="text" class="form-control mayuscula"
                  v-model="cliente" maxlength="50"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.modificacionReservaciones.nombreUsuario')}}*</label>
              <div class="Pos-r">
                <input type="text" class="form-control minuscula"
                  v-model="usuario" maxlength="50"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.modificacionReservaciones.correoElectronico')}}*</label>
              <div class="Pos-r">
                <input
                maxlength="50"
                  type="email"
                  :placeholder="$t('language.posadasCorporate.modificacionReservaciones.ejemplo') + '@' + $t('language.posadasCorporate.modificacionReservaciones.correo') + '.com'"
                  class="form-control"
                  v-model="correo"
                  :class="{ 'is-invalid': (!$v.correo.email)}"/>
                <span class="notas" v-if="!$v.correo.email">{{$t('language.posadasCorporate.reservacionesRegistro.invalidEmail')}}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.modificacionReservaciones.claveConfirmacion')}}*</label>
              <div class="Pos-r">
                <input
                
                  type="number"
                  :placeholder="$t('language.posadasCorporate.modificacionReservaciones.caracteres10')"
                  class="form-control"
                  :value="clave" @input="updateValue"
                  onkeypress="return event.key === 'Enter' || (Number(event.key) >= 0 && Number(event.key) <= 9)"
               
                  />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.modificacionReservaciones.fechasActuales')}}*</label>
              <div class="Pos-r">
                <div class="d-block">
                  <div>
                    <div
                      class="entradaInput position-relative d-inline-block w-50"
                      v-if="banDatePicker"
                    >
                      <i
                        class="calendarIcon demo-icon icon-calendar position-absolute"
                        v-if="entrada.length < 1"
                      ></i>
                      <i
                        class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute"
                        v-else
                        @click="[entrada = '',salida = '']"
                      ></i>
                       <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="es"
                    :clearable="false" placeholder="Entrada" format="DD/MM/YYYY"
                    :not-before="todayDate"   v-if="tryingAgain == 'es'"></datepicker>  <!--  -->
                     <datepicker class="w-100 fechaEntrada" v-model="entrada" lang="en"
                    :clearable="false" placeholder="Check in" format="MM/DD/YYYY"
                    :not-before="todayDate"  v-if="tryingAgain == 'en'"></datepicker>
                    </div>
                    <div
                      class="entradaInput position-relative d-inline-block w-50"
                      v-if="banDatePicker"
                    >
                      <i
                        class="calendarIcon demo-icon icon-calendar position-absolute"
                        v-if="salida.length < 1"
                      ></i>
                      <i
                        class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute"
                        v-else
                        @click="salida = ''"
                      ></i>
                         <datepicker class="w-100 fechaSalida" v-model="salida" lang="es" :clearable="false"
                  placeholder="Salida" format="DD/MM/YYYY" :not-before="entrada"
                  :disabled-days="[entrada]" :disabled="!entrada" v-if="tryingAgain == 'es'"></datepicker>
                  <datepicker class="w-100 fechaSalida" v-model="salida" lang="en" :clearable="false"
                  placeholder="Check out" format="MM/DD/YYYY" :not-before="entrada"
                  :disabled-days="[entrada]" :disabled="!entrada" v-if="tryingAgain == 'en'"></datepicker>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.modificacionReservaciones.fechasDeseadas')}}*</label>
              <div class="Pos-r">
                <div class="d-block">
                  <div>
                    <div
                      class="entradaInput position-relative d-inline-block w-50"
                      v-if="banDatePicker"
                    >
                      <i
                        class="calendarIcon demo-icon icon-calendar position-absolute"
                        v-if="entradaDos.length < 1"
                      ></i>
                      <i
                        class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute"
                        v-else
                        @click="[entradaDos = '',salidaDos = '']"
                      ></i>
                           <datepicker class="w-100 fechaEntrada" v-model="entradaDos" lang="es"
                    :clearable="false" placeholder="Entrada" format="DD/MM/YYYY"
                    :not-before="todayDate"   v-if="tryingAgain == 'es'"></datepicker>
                     <datepicker class="w-100 fechaEntrada" v-model="entradaDos" lang="en"
                    :clearable="false" placeholder="Check in" format="MM/DD/YYYY"
                    :not-before="todayDate"  v-if="tryingAgain == 'en'"></datepicker>
                    </div>
                    <div
                      class="entradaInput position-relative d-inline-block w-50"
                      v-if="banDatePicker"
                    >
                      <i
                        class="calendarIcon demo-icon icon-calendar position-absolute"
                        v-if="salidaDos.length < 1"
                      ></i>
                      <i
                        class="calendarIcon limpiarCalendario demo-icon icon-close position-absolute"
                        v-else
                        @click="salidaDos = ''"
                      ></i>
                            <datepicker class="w-100 fechaSalida" v-model="salidaDos" lang="es" :clearable="false"
                  placeholder="Salida" format="DD/MM/YYYY" :not-before="entradaDos"
                  :disabled-days="[entradaDos]" :disabled="!entradaDos" v-if="tryingAgain == 'es'"></datepicker>
 <datepicker class="w-100 fechaSalida" v-model="salidaDos" lang="en" :clearable="false"
                  placeholder="Check out" format="MM/DD/YYYY" :not-before="entradaDos"
                  :disabled-days="[entradaDos]" :disabled="!entradaDos" v-if="tryingAgain == 'en'"></datepicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.modificacionReservaciones.comentariosAdicionales')}}</label>
              <div class="Pos-r">
                <textarea v-model="adicionales" maxlength="255"></textarea>
                <label for="" class="notas">{{$t('language.posadasCorporate.generals.max255Caracteres')}}</label><br><br>
                <small>* {{$t('language.posadasCorporate.modificacionReservaciones.camposRequeridos')}}</small>
              </div>
            </div>
          </div>
          <div class="col-12 mt-2 mb-5">
            <Loader v-if="banLoader" />
            <div class="row">
              <div class="col-4"></div>
              <div class="col-12 col-md-4">
                <router-link
                  to="/informacion-corporate"
                  tag="button"
                  class="mt-3 secondary-button"
                >{{$t('language.posadasCorporate.modificacionReservaciones.regresar')}}</router-link>
              </div>
              <div class="col-12 col-md-4">
                <button
                  class="mt-3 primary-button"
                  @click="enviar"
                  :disabled="isDisabled || banLoader"
                >{{$t('language.posadasCorporate.modificacionReservaciones.enviar')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde">
          <i class="demo-icon icon-check-fill Fw-bolder"></i>
          {{$t('language.posadasCorporate.modificacionReservaciones.titleModal')}}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{textModal}}</p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary"
          @click="closeModal"
          aria-label="Close modal"
        >{{$t('language.posadasCorporate.modificacionReservaciones.entendido')}}</button>
      </template>
    </modal>
    <Footer />
  </div>
</template>

<script>
import * as GlobalFunctions from "../../../utils/GlobalFunctions";
import * as GlobalServices from "../../../utils/GlobalServices";
import Header from "../../generales/Header.vue";
import Footer from "../../generales/Footer.vue";
import Datepicker from "vue2-datepicker";
import Modal from "../../addons/Modal.vue";
import SecureLS from "secure-ls";
import i18n from "../../../plugins/i18n";
import Loader from "../../loader/Loader";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "Contacto",
  components: {
    Header,
    Footer,
    Datepicker,
    Modal,
    Loader
  },
  data() {
    return {
          validRegex: /^[a-zA-Z\\d\\1-9\\0]*$/,
        validRegexEmail: /^[a-zA-Z\\d\\1-9\\0\\.\\_\\@\\-]*$/,
        validRegexUsuario: /^[a-zA-Z\\d\\.]*$/,
        todayDate: new Date(),

      banLoader: false,
      textModal: "",
      localLanguage: "",
      banDatePicker: false,
      datePickerFormat: {
        language: "",
        format: ""
      },
      dateFormatEs: "DD/MM/YYYY", //no cambiar este valor
      dateFormatEn: "MM/DD/YYYY", //no cambiar este valor
      ls: new SecureLS({ encodingType: "aes" }),
      isModalVisible: false,
      cliente: "",
      usuario: "",
      correo: "",
      clave: null,
      adicionales: "",
      // Calendario
      entrada: "",
      entradaDos: "",
      salida: "",
      salidaDos: ""
    };
  },
  validations: {
    correo: {
      required,
      email,
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    updateValue(event) {
      const value = event.target.value
      if (String(value).length <= 10) {
        this.clave = value
      }
      this.$forceUpdate()
    },
    configAvailibility() {
      // Modify modal "Rooms" section configuaration
      axios
        .get(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_HOTEL +
            `/${availibilityRequest.data.hotelCode}/` +
            process.env.VUE_APP_CONFIG,
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.token,
              "Accept-language": this.language.data
            }
          }
        )
        .then(res => {
          this.salida = availibilityRequest.data.departureDate;
          this.roomCodesListings = [];
          this.roomCodesListings2 = [];
          if (res.status == 200 || res.status == 201) {
            this.personas = this.adultos + this.menores + this.infantes;
            this.ouiLesF = res.data.response.infantsAllowed;
            this.ouiLesG = res.data.response.childrenAllowed;
            if (
              res.data.response.adultsAllowed == true &&
              res.data.response.infantsAllowed == false &&
              res.data.response.childrenAllowed == false
            ) {
              for (var i = 0; i < this.hoteles.length; i++) {
                if (this.search == this.hoteles[i].nombre) {
                  this.hoteles[i].adults = true;

                  this.isForAdults(this.search);
                }
              }
            }
            var roomList = res.data.response.roomList;
            this.roomListings = res.data.response.roomList;
            ls.set("hotelConfiguration", this.roomListings);
            this.roomListings.sort(function(a, b) {
              return a.categoryName.localeCompare(b.categoryName);
            });
            for (var i = 0; i < this.roomListings.length; i++) {
              for (var j = 0; j < this.roomListings[i].roomCodes.length; j++) {
                this.roomCodesListings.push(this.roomListings[i].roomCodes[j]);
                this.roomCodesListings2.push(this.roomListings[i].roomCodes[j]);
              }
            }
            this.maxRoomsAllowed = res.data.response.maxRooms;
            this.maxAdultsAllowed = res.data.response.maxAdults;
            this.maxChildrenAllowed = res.data.response.maxChildren;
            this.maxInfantsAllowed = res.data.response.maxInfants;
            if (res.data.response.validCurrencies.length == 2) {
              for (
                var i = 0;
                i < res.data.response.validCurrencies.length;
                i++
              ) {
                if (res.data.response.validCurrencies[i] == "USD") {
                  this.americanCurrency = res.data.response.validCurrencies[i];
                }
                if (res.data.response.validCurrencies[i] == "MXN") {
                  this.mexicanCurrency = res.data.response.validCurrencies[i];
                }
              }
            }
            if (res.data.response.validCurrencies.length == 1) {
              if (res.data.response.validCurrencies[0] == "USD") {
                this.americanCurrency = res.data.response.validCurrencies[i];
                this.mexicanCurrency = "";
              }
              if (res.data.response.validCurrencies[0] == "MXN") {
                this.mexicanCurrency = res.data.response.validCurrencies[i];
                this.americanCurrency = "";
              }
            }
            if (this.roomsTypeIsFull) {
              this.typeRooms = [];
              this.selected = [];
              for (var i = 0; i < roomList.length; i++) {
                this.typeRooms.push({
                  id: i,
                  checked: true,
                  name: roomList[i].categoryName
                });
              }
              this.typeRooms.sort(function(a, b) {
                return a.name.localeCompare(b.name);
              });
            } else {
              for (var i = 0; i < roomList.length; i++) {
                this.typeRooms.push({
                  id: i,
                  checked: true,
                  name: roomList[i].categoryName
                });
              }
              this.typeRooms.sort(function(a, b) {
                return a.name.localeCompare(b.name);
              });
              this.roomsTypeIsFull = true;
            }
          }
          if (res.status == 401) {
            this.clearLocalStorage();
          }
        })
        .catch(error => {
          if (error.response.data.errorCode == "RSP_HOTEL_CONFIG_01") {
            this.typeRooms = [];
          }
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
    },
    enviar() {
      const localProfile = this.ls.get("Profile").data;
      this.banLoader = true;
      var data = {
        profileId: this.cliente.toUpperCase(),
        username: this.usuario.toLowerCase(),
        userType: localProfile.userType,
        reservationNumber: this.clave,
        arrivalDateReal: GlobalFunctions.convertBeautifulDate(
          this.entrada,
          this.ls.get("Language").data
        ),
        departureDateReal: GlobalFunctions.convertBeautifulDate(
          this.salida,
          this.ls.get("Language").data
        ),
        arrivalDateDesired: GlobalFunctions.convertBeautifulDate(
          this.entradaDos,
          this.ls.get("Language").data
        ),
        departureDateDesired: GlobalFunctions.convertBeautifulDate(
          this.salidaDos,
          this.ls.get("Language").data
        ),
        email: this.correo,
        commentsAdditional: this.adicionales
      };
      GlobalServices._modificarAclaracionReservacion(
        this.ls.get("Token").data,
        this.ls.get("Language").data,
        data
      )
        .then(response => {
          if (response.status === 200) {
            this.textModal = response.data.message;
            this.banLoader = false;
            this.isModalVisible = true;
          } else {
            this.$router.push({ name: "Error" });
          }
        })
        .catch(error => {
          if (error.status == 401) {
            this.sesionClose();
          } else {
            this.$router.push({ name: "Error" });
          }
        });
    },
    closeModal() {
      this.isModalVisible = false;
      setTimeout(() => {
        this.$router.push({ name: "InformacionCorporate" });
      }, 200);
    },
    formatDatepicker() {
      const lang = this.ls.get("Language").data;
      this.datePickerFormat.language = lang;
      this.datePickerFormat.format =
        lang === "es" ? this.dateFormatEs : this.dateFormatEn;
      this.banDatePicker = true;
    },
    sesionClose() {
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: "Login" });
    },
    limpiarForm() {
      this.closeModal();
      setTimeout(() => {
        this.cliente = "";
        this.usuario = "";
        this.correo = "";
        this.clave = "";
        this.entrada = "";
        this.salida = "";
        this.entradaDos = "";
        this.salidaDos = "";
        this.adicionales = "";
        this.textModal = "";
      }, 350);
    }
  },
  created() {
    this.localLanguage = this.ls.get("Language").data;
    this.formatDatepicker();
    this.configAvailibility();
  },
  computed: {
    inpNum:{
            get:function(){
                return this.oldNum;
            
            },
            set:function(newValue){
                this.oldNum=newValue.replace(/[^\d]/g,'');
            }
        },
        tryingAgain() {
        if(this.$store.getters.gettingLang == 'es') {
        return this.$store.getters.gettingLang
} else {
        return this.$store.getters.gettingLang
        }
        
        },
  
    isDisabled() {
      if (
        this.cliente.length > 1 &&
        this.usuario.length > 1 &&
        this.clave.length >= 1 &&
        this.entrada &&
        this.salida &&
        this.entradaDos &&
        this.salidaDos &&
        this.correo.length > 1
      ) {
        if (this.correo.length != '') {
          if (this.correo.length > 6 && this.$v.correo.email) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    titleModificacioneReservaciones() {
      if (this.localLanguage !== this.ls.get("Language").data) {
        this.localLanguage = this.ls.get("Language").data;
        this.banDatePicker = false;
        setTimeout(() => {
          this.formatDatepicker();
        }, 1);
      }
      return i18n.t(
        "language.posadasCorporate.modificacionReservaciones.modificacioneReservaciones"
      );
    }
  },
  watch:{
      correo() {
        
            let str = "";
            if (!this.validRegexEmail.test(this.correo)) {
              str = this.correo.substring(0, this.correo.length - 1);
              this.correo = str;
            }
      },
      usuario() {
            let str = "";
            if (!this.validRegexUsuario.test(this.usuario)) {
              str = this.usuario.substring(0, this.usuario.length - 1);
              this.usuario = str;
            }
      },
        cliente() {
          let str = "";
            if (!this.validRegex.test(this.cliente)) {
              str = this.cliente.substring(0, this.cliente.length - 1);
              this.cliente = str;
            }
        },
    entrada(){
    if( this.entrada ) {
        var fechaEntrada = new Date(this.entrada),
        dias = 1
        this.salida = fechaEntrada.setDate(fechaEntrada.getDate() + dias);
      }
    },
    entradaDos(){
    if( this.entradaDos ) {
        var fechaEntrada = new Date(this.entradaDos),
        dias = 1
        this.salidaDos = fechaEntrada.setDate(fechaEntrada.getDate() + dias);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/config.scss";
.card-height-custom {
  min-height: 213.67px;
  height: 213.67px;
  .card-body {
    min-height: 213.67px;
    height: 213.67px;
  }
}
textarea {
  height: 130px;
}
</style>